import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "durationFields"];

  connect() {
    this.updateVisibility();
  }

  toggle() {
    this.updateVisibility();
  }

  updateVisibility() {
    if (this.hasToggleTarget) {
      const showDurations = this.toggleTarget.checked;
      if (showDurations) {
        this.durationFieldsTarget.classList.remove("hidden");
      } else {
        this.durationFieldsTarget.classList.add("hidden");
      }
    }
  }
}